import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NotificacionesService, TipoNotificacionesVisualizadas } from '@abm/notificacion/notificaciones.service';
import { ErrorModel } from '@shared/models/ErrorModel';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificacionUsuarioEncabezado } from '@shared/models/notificaciones/NotificacionUsuarioEncabezado';
import { NotificacionDetalleComponent } from '../notificacion-detalle/notificacion-detalle.component';
@Component({
  selector: 'app-notificaciones-usuario',
  templateUrl: './notificaciones-usuario.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./notificaciones-usuario.component.css']
})
export class NotificacionesUsuarioComponent implements OnInit {

  TipoNotificacionesVisualizadas = TipoNotificacionesVisualizadas;

  throttle = 500;
  distance = 2;
  page = 1;
  pageSize = 20;

  notificaciones: NotificacionUsuarioEncabezado[];
  obteniendoNotificaciones: boolean;
  obteniendoNotificacionesScroll: boolean;
  notificacionesVisualizadas: TipoNotificacionesVisualizadas = TipoNotificacionesVisualizadas.Todas;
  stopScroll:boolean;

  constructor(  private notificacionesService: NotificacionesService,
                private modalService: NgbModal,
                public activeModal: NgbActiveModal) { }

  ngOnInit() {
    this.obtenerNotificaciones(this.page, false);
  }

  onUsuarioSeleccionoFiltrarNotificaciones(tipoNotificacionesMostradas: TipoNotificacionesVisualizadas){
    this.notificacionesVisualizadas = tipoNotificacionesMostradas;
    this.page = 1;
    this.obtenerNotificaciones(this.page, false);
  }

  obtenerNotificaciones(page: number, isScroll: boolean){
    if( !isScroll ){
      this.obteniendoNotificaciones = true;
    }else{
      this.obteniendoNotificacionesScroll = true;
    }


    this.notificacionesService.getNotificacionesUsuario(page, this.pageSize, this.notificacionesVisualizadas)
      .subscribe(
        (notificaciones: NotificacionUsuarioEncabezado[]) => {
          notificaciones.length == 0 ? this.stopScroll = true : this.stopScroll = false;
          if( !isScroll ){
            this.notificaciones = notificaciones;
            this.obteniendoNotificaciones = false;
          }else{
            this.notificaciones = this.notificaciones.concat(notificaciones);
            this.obteniendoNotificacionesScroll = false;
          }
        },
        (error: ErrorModel) => {
          console.log(error);
          if( !isScroll ){
            this.obteniendoNotificaciones = false;
          }else{
            this.obteniendoNotificacionesScroll = false;
          }
        }
      );
  }

  usuarioSeleccionoNotificacion(n: NotificacionUsuarioEncabezado){
    const  ahora = new Date();
    n.fechaHoraLectura = this.formatDate(ahora.getFullYear(), ahora.getMonth(), ahora.getDate(), ahora.getHours, ahora.getMinutes);

    const modalRef = this.modalService.open(NotificacionDetalleComponent, { size: 'lg', windowClass: 'modalNotificacionDetalle', backdrop: 'static' });
    modalRef.componentInstance.encabezado = n;
  }

  onScrollNotificaciones(){
    this.obtenerNotificaciones(++this.page, true);
  }

  formatDate(year, month, day, hour, minute): string {
    return year + '-' + month.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + '-' + day.toLocaleString(undefined, { minimumIntegerDigits: 2 })
      + 'T' + hour.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + ':' + minute.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + ':00';
  }

}
